// =====================================================================
// Empleados / técnicos (capa de operaciones). Matchea enum/modelo Prisma.
// =====================================================================
/** Habilidades válidas del técnico (multi-tag, field-service). */
export const EMPLOYEE_SKILLS = ['madera', 'polimetal', 'ambas', 'productos'];
//# sourceMappingURL=employee.js.map